import {Section} from "./Section";

export class PaymentSection extends Section {

  constructor(sectionElement) {
    super(sectionElement);

    this.previousSectionButton = this.element.querySelector('[data-button="prev"]');
    this.nextSectionButton = this.element.querySelector('[data-button="next"]');
  }

}

export const INSTANTIATE_PAYMENT_SECTION = () => {
  const PAYMENT_SECTION_ELEMENT = document.querySelector('[data-section="payment"]');
  if (!PAYMENT_SECTION_ELEMENT) return;

  return new PaymentSection(PAYMENT_SECTION_ELEMENT);
}
